import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=6e379ab2&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e379ab2",
  null
  
)

component.options.__file = "OrderItem.vue"
export default component.exports